const subject = {
  namespaced: true,
  state: {
    metadata: {
      'mod': 'nis-subject'
    },
    subjectDeatilMetadata: {
      'mod': 'nis-subjectqa' // 待确认
    }
  },
  getters: {},
  mutations: {
  },
  actions: {}
}

export default subject
